/* GetActive – product page polish for the Instant template (product.instant-6OXQe2c9kA5aSLMM).
   Loaded with defer by snippets/custom-code-head.liquid for that template only.

   Instant's drawers ("Beskrivelse", "Næringsindhold og ingredienser") scroll right down to the
   bottom of the screen, so anything fixed over that edge – Shopify's preview bar in a theme
   preview, a chat button – hides their last lines. While a drawer is open this measures how
   much of its scroll area is covered and publishes it as --ga-drawer-cover on the drawer;
   assets/getactive-product.css adds that to the room under the text. */
// Reviews drawer (snippets/getactive-source-rating.liquid): the card opens the real reviews from the
// right. The drawer moves to <body> on first use so no ancestor's transform or overflow can clip it.
(() => {
  const opener = document.querySelector('[data-ga-reviews-open]');
  const drawer = document.getElementById('ga-rv');
  if (!opener || !drawer) return;
  const html = document.documentElement;
  const panel = drawer.querySelector('.ga-rv__panel');
  let moved = false;
  const open = () => {
    if (!moved) { document.body.appendChild(drawer); moved = true; }
    drawer.hidden = false;
    void drawer.offsetWidth; // so the slide-in starts from the closed position
    drawer.classList.add('ga-rv--open');
    html.classList.add('ga-rv-lock');
    opener.setAttribute('aria-expanded', 'true');
    panel.focus({ preventScroll: true });
    document.addEventListener('keydown', onKey);
  };
  const close = () => {
    drawer.classList.remove('ga-rv--open');
    html.classList.remove('ga-rv-lock');
    opener.setAttribute('aria-expanded', 'false');
    document.removeEventListener('keydown', onKey);
    const done = () => { if (!drawer.classList.contains('ga-rv--open')) drawer.hidden = true; };
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) done(); else setTimeout(done, 320);
    opener.focus({ preventScroll: true });
  };
  const onKey = (e) => {
    if (e.key === 'Escape') close();
    else if (e.key === 'Tab') {
      // Keep Tab inside the open drawer
      const items = [...panel.querySelectorAll('button, [href], [tabindex]:not([tabindex="-1"])')];
      if (!items.length) return;
      const first = items[0], last = items[items.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  };
  opener.addEventListener('click', open);
  drawer.addEventListener('click', (e) => { if (e.target.closest('[data-ga-reviews-close]')) close(); });
})();

(() => {
  // Design option under review (part 4 of the CSS), switched on before paint by the inline script
  // in snippets/custom-code-head.liquid.
  const root = document.documentElement;
  const motion = root.classList.contains('ga-motion');

  if (motion) {
    // In a theme preview Shopify's preview bar covers the bottom of the screen: publish how much,
    // so the phones' add-to-cart bar can sit above it. Nothing happens on the live store.
    let watched = null;
    const publish = () => {
      const bar = document.getElementById('PBarNextFrameWrapper');
      if (bar && bar !== watched) {
        watched = bar;
        new ResizeObserver(publish).observe(bar);
      }
      const box = bar && bar.getClientRects().length ? bar.getBoundingClientRect() : null;
      const covered = box && box.bottom >= window.innerHeight - 1 ? Math.round(window.innerHeight - box.top) : 0;
      if (covered > 0 && covered < 160) root.style.setProperty('--ga-pbar', `${covered}px`);
      else root.style.removeProperty('--ga-pbar');
    };
    window.addEventListener('load', () => {
      publish();
      setTimeout(publish, 1500);
    });
    window.addEventListener('resize', publish);

    // Flavours (and any other option) as chips. The chips drive Instant's own select, so price,
    // stock and the cart keep working; without this script the dropdown simply stays.
    document.querySelectorAll('.__instant .i3yanuxWocVUeUvGk fieldset.instant-variant-picker--select').forEach((picker) => {
      const select = picker.querySelector('select');
      if (!select || select.options.length < 2) return;
      const legend = picker.querySelector('legend');
      const group = document.createElement('div');
      group.className = 'ga-chips';
      group.setAttribute('role', 'radiogroup');
      group.setAttribute('aria-label', legend ? legend.textContent.trim() : 'Variant');
      for (const option of select.options) {
        const chip = document.createElement('label');
        chip.className = 'ga-chip';
        const input = document.createElement('input');
        input.type = 'radio';
        input.name = `ga-chip-${select.name}`;
        input.setAttribute('form', 'ga-chips-none'); // keeps the chips out of the cart form
        input.value = option.value;
        input.checked = option.selected;
        input.disabled = option.disabled;
        // The option's value, not its text: Instant appends "- Unavailable" to sold-out options
        // and marks them data-instant-disabled. Those stay selectable, struck through.
        const label = document.createElement('span');
        label.textContent = option.value.trim();
        chip.append(input, label);
        if (option.getAttribute('data-instant-disabled') === 'true') {
          chip.classList.add('ga-chip--out');
          const note = document.createElement('span');
          note.className = 'ga-chip__note';
          note.textContent = ' – udsolgt';
          chip.append(note);
        }
        group.append(chip);
      }
      // The chips' own events stop here; Instant only hears its select.
      group.addEventListener('input', (event) => event.stopPropagation());
      group.addEventListener('change', (event) => {
        event.stopPropagation();
        select.value = event.target.value;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
      select.addEventListener('change', () => {
        for (const input of group.querySelectorAll('input')) input.checked = input.value === select.value;
      });
      picker.after(group);
      picker.setAttribute('data-ga-chips', '');
    });

    // Nutrition tables: kJ over kcal, as on a printed label, so the figures fit a phone. Display
    // only; the text in admin is untouched.
    document.querySelectorAll('.__instant [data-instant-type="overlay"] td').forEach((cell) => {
      if (cell.children.length || !/kJ\s*\/\s*\d/.test(cell.textContent)) return;
      const [kj, kcal] = cell.textContent.split('/').map((part) => part.trim());
      cell.replaceChildren(kj, document.createElement('br'), kcal);
    });

    // Phones: with the add-to-cart row back in the buy box, the bottom bar holds back while that
    // row is on screen (Instant still decides when the bar may show at all).
    const inlineAtc = document.querySelector('.__instant .i3yanuxWocVUeUvGk .iMm9Qj1FmQvgXLd5n');
    if (inlineAtc && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => root.classList.toggle('ga-atc-in', entry.isIntersecting)).observe(inlineAtc);
    }
  }

  const overlays = document.querySelectorAll('.__instant [data-instant-type="overlay"]');
  if (!overlays.length) return;

  const isOpen = (overlay) => overlay.getAttribute('data-state') === 'open';

  const measure = (overlay) => {
    const area = overlay.querySelector('.instant-open-overlay > :last-child');
    if (!area) return;
    const box = area.getBoundingClientRect();
    const edge = Math.min(box.bottom, window.innerHeight) - 1;
    let top = edge + 1;
    // Whatever is on top along the bottom edge and isn't the drawer itself covers it; its fixed
    // container gives the height of the bar.
    for (const x of [box.left + 12, (box.left + box.right) / 2, box.right - 12]) {
      const hit = document.elementFromPoint(x, edge);
      if (!hit || overlay.contains(hit)) continue;
      let bar = hit;
      while (bar && getComputedStyle(bar).position !== 'fixed') bar = bar.parentElement;
      top = Math.min(top, (bar || hit).getBoundingClientRect().top);
    }
    const covered = Math.min(Math.round(edge + 1 - top), Math.round(box.height / 2));
    if (covered > 0) overlay.style.setProperty('--ga-drawer-cover', `${covered}px`);
    else overlay.style.removeProperty('--ga-drawer-cover');
  };

  const observer = new MutationObserver((records) => {
    for (const { target } of records) {
      if (!isOpen(target)) continue;
      measure(target);
      // Again once the slide-in has finished
      setTimeout(() => isOpen(target) && measure(target), 600);
    }
  });
  overlays.forEach((overlay) => observer.observe(overlay, { attributes: true, attributeFilter: ['data-state'] }));

  window.addEventListener('resize', () => overlays.forEach((overlay) => isOpen(overlay) && measure(overlay)));

  // Option: the pinned drawer title gets a hairline once text scrolls under it.
  if (motion) {
    overlays.forEach((overlay) => {
      const area = overlay.querySelector('.instant-open-overlay > :last-child');
      if (area) area.addEventListener('scroll', () => overlay.toggleAttribute('data-ga-scrolled', area.scrollTop > 2), { passive: true });
    });
  }
})();
